const ERROR_KEYS = {
  VERTEX_MODEL_NOT_FOUND: 'errorVertexModelNotFound',
  VERTEX_PERMISSION_DENIED: 'errorVertexPermissionDenied',
  AGENT_NOT_FOUND: 'errorAgentNotFound',
  SESSION_NOT_FOUND: 'errorSessionNotFound',
  UNKNOWN_RUNTIME_ERROR: 'errorUnknownRuntime',
};

export function getRuntimeErrorKey(errorCode, source) {
  if (errorCode && ERROR_KEYS[errorCode]) {
    return ERROR_KEYS[errorCode];
  }

  if (source === 'VertexAI') {
    return ERROR_KEYS.VERTEX_MODEL_NOT_FOUND;
  }
  if (source === 'AgentManager') {
    return ERROR_KEYS.AGENT_NOT_FOUND;
  }
  if (source === 'SessionManager') {
    return ERROR_KEYS.SESSION_NOT_FOUND;
  }

  return ERROR_KEYS.UNKNOWN_RUNTIME_ERROR;
}

export function resolveRuntimeErrorMessage(errorKey, texts = {}) {
  if (errorKey && texts[errorKey]) {
    return texts[errorKey];
  }
  return texts.errorUnknownRuntime || '';
}
